import React from 'react'
import SupportBanner from '../components/SupportBanner'
import ServicesSection from '../components/ServicesSection'
import ServicesHeader from '../components/ServicesHeader'
import Navbar from '../components/Navbar'
import AppBar from '../components/Appbar'
import ServicesPage from '../components/ServicesPage'
import HeroSection from '../components/HeroSection'
import TransportForm from '../components/TransportForm'
import Footer from '../components/Footer'

function Services() {
  return (
    <div>
        <Navbar />
        <ServicesHeader />
        <ServicesPage />
        <SupportBanner />
        <ServicesSection    />
        <HeroSection />
        <TransportForm />
        <Footer />
    </div>
  )
}

export default Services